import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * Validates an email address according to specified requirements
 * @param {string} email - The email address to validate
 * @returns {boolean} - Whether the email is valid
 */
export function isValidEmail(email) {
  // 2. Check length (5-254 characters)
  if (email.length < 5 || email.length > 254) {
    return false;
  }

  // 3. Check for exactly one @ symbol
  var atSymbolCount = (email.match(/@/g) || []).length;
  if (atSymbolCount !== 1) {
    return false;
  }

  // 4. Split into local and domain parts
  var _email$split = email.split('@'),
    _email$split2 = _slicedToArray(_email$split, 2),
    localPart = _email$split2[0],
    domainPart = _email$split2[1];

  // 5. Check if both parts exist
  if (!localPart || !domainPart) {
    return false;
  }

  // 6. Check for prohibited characters in the entire email
  // Only allow: a-z, 0-9, ., -, _, and @
  if (!/^[a-z0-9._@-]+$/i.test(email)) {
    return false;
  }

  // 7. Check local part
  // Cannot start or end with ., -, _
  if (/^[._-]|[._-]$/.test(localPart)) {
    return false;
  }

  // 8. Check domain part
  // Must contain at least one dot
  if (!domainPart.includes('.')) {
    return false;
  }
  var d = domainPart.split('.');

  // 9. Check TLD (part after the last dot)
  var tld = d.pop();
  if (!tld || tld.length < 2) {
    return false;
  }
  var sub = d.pop();
  if (!sub) return false;

  // Cannot start or end with ., -
  if (/^[._-]|[._-]$/.test(sub)) {
    return false;
  }

  // 10. Check if TLD only contains letters
  return !!/^[a-z]+$/i.test(tld);
}